var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature flex align-center"},[_c('h4',{staticClass:"flex align-center c-primary fw-medium"},[_c('icon',{staticClass:"inline",attrs:{"colour":"#B95A25","width":"36","height":"36"}},[_vm._t("icon")],2),_vm._v(" "),_vm._t("text")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09eed768","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Feature.vue
// module id = null
// module chunks = 